import { createFileRoute } from '@tanstack/react-router';

import CertificationView from '@/ui/pages/CertificationView/CertificationView';

export const Route = createFileRoute('/_dashboard/certifications/$id/')({
  component: CertificationView,
});
